export default __webpack_public_path__ + "static/media/gangster.b43424f4.png";